import { Model } from '../abstracts/model';
import { FilterModel } from './filter.model';

export class CategoryModel extends Model {
  id: number;
  slug: string;
  title: string;
  description: string;
  children: CategoryModel[];
  filters: FilterModel[];

  override onInit(): void {
    if (this.children?.length) {
      this.children = this.children.map((itm) => new CategoryModel(itm));
    }
    if (this.filters?.length) {
      this.filters = this.filters.map((itm) => new FilterModel(itm));
    }
  }
}
